export const az = {
  title: 'Torpaq örtüyü 2000-2020',
  subtitle: 'UMD',
  download_data: '',
  learn_more: '',
  content: [
    {
      label: 'Funksiya',
      value: '2000 və 2020-ci il üçün qlobal torpaq istifadəsi və torpaq örtüyü xəritəsi',
    },
    {
      label: 'Qətmə',
      value: '30 metr',
    },
    {
      label: 'Coğrafi əhatə',
      value: 'Qlobal',
    },
    {
      label: 'Mənbə',
      value: 'UMD',
    },
    {
      label: 'Tezlik',
      value: '',
    },
    {
      label: 'Məzmun tarixi',
      value: '',
    },
    {
      label: 'Xəbərdarlıqlar',
      value:
        '- Landsat aydın-göy məlumatların mövcudluğu ilə torpaq örtüyü xəritələşdirilməsi məhdud idi. Landsat müşahidə vaxt seriyasının natamamlığı davamlı bulud örtüyü olan bölgələrdə xəritə dəqiqliyini azaldır. \n- Heterogen landşaftlarda diskret torpaq örtüyü siniflərinin xəritələşdirilməsi Landsat spatial qətnaməsində qarışıq piksellərin yüksək nisbəti ilə məhdudlaşdırılmışdı. Lulc siniflərinin əksəriyyəti parçalanmış landşaft və sinif yamaq kənarları ilə müqayisədə böyük homogen sahələr üzərində daha yüksək xəritə dəqiqliyinə malikdirlər. \n- Müxtəlif LCLU sinifləri arasındakı spektral oxşarlıq sinif ayrı-seçkiliyini önlənə bilər.\n- Meşə hündürlüyü məhsulunun GEDI məlumat keyfiyyəti və Landsat məlumatlarının mövcudluğu ilə bağlı məsələləri var. 2000-2020-ci illər arasında meşə hündürlüyünün kiçik dəyişməsi faktiki meşə strukturunun dəyişməsini göstərməsə də, model çıxıntılardakı səs-küyü təmsil edir. \n- Dinamik siniflər (LCLU sinif itkisi və qazanılma) statik xəritələrlə müqayisədə daha aşağı dəqiqliyə malikdirlər. \n- Xəritə əsaslı hesablamalar xəritə qeyri-müəyyənliyinin naməlum spatial və temporal dəyişkənliyinə görə milli və beynəlxalq hesabatlar üçün yetərli deyil.',
    },
    {
      label: 'Lisenziya',
      value: 'Creative Commons Attribution License (https://glad.umd.edu/dataset/GLCLUC2020)',
    },
  ],
  overview: {
    label: 'Ümumi baxış',
    value:
      'Qlobal torpaq istifadəsi və torpaq örtüyü xəritələri Qlobal Torpaq Analizi və Kəşf Laboratoriyası (GLAD) laboratoriyası tərəfindən yaradılmışdır. Məlumatlar 2000 və 2020-ci il üçün 30 m spatial qətnamədə mövcuddur. GLAD laboratoriyasında spatiotemporally ardıcıl [Landsat Analysis Ready Data (GLAD ARD)](https://glad.umd.edu/ard) istifadə edərək meşə miqyası və hündürlüyü, əkin sahələri, tikilmiş torpaqlar, səthi sular və iyirmi il ərzində əbədi qarın və buzun genişliyi dəyişikliklərini kvantlaşdırmaq üçün istifadə edilmişdir. Hər bir tematik məhsul müstəqil olaraq dövlət, yerli və regional kalibrli maşın öyrənmə vasitələrindən istifadə etməklə əldə edilirdi. Dataset onun yüksək dəqiqliyini təsdiq edən statistik bir sampling vasitəsi ilə təsdiqlənmişdir. UMD-nin Coğrafi Elmlər Departamentində yerləşən "Global Land Analysis and Discovery Lab" (GLAD) laboratoriyasında qlobal torpaq səthinin dəyişməsinin metodları, səbəbləri və təsirləri araşdırılır. Yer müşahidə imagery əsas məlumat mənbəyidir. Torpaq əhatə miqyası və dəyişiklik əsas maraq mövzusudur. GLAD torpaq resursları ilə bağlı yeni elmi anlayışlar yaratmaq, uzaq sensasiyaya əsaslanan torpaqların dəyişdirilməsi üzrə alimlərin növbəti nəslini maarifləndirmək, ölkə və beynəlxalq miqyasda operativ şəraitdə torpaq monitorinqi imkanlarını yaymaq arzusundadır.',
  },
  citation: {
    label: 'Sitat',
    value:
      'Potapov P., Hansen M.C., Pickens A., Hernandez-Serna A., Tyukavina A., Turubanova S., Zalles V., Li X., Khan A., Stolle F., Harris N., Song X.-P., Baggett A., Kommareddy I., Kommareddy A. (2022) The global 2000-2020 land cover and land use change dataset derived from the Landsat archive: first results. Frontiers in Remote Sensing. [https://doi.org/10.3389/frsen.2022.856903](https://doi.org/10.3389/frsen.2022.856903). Accessed through Resource Watch, (date). [www.resourcewatch.org](https://www.resourcewatch.org).',
  },
};
